import { profileActionTypes } from "../actions/index";

const initialState = {
    list: [],
    isLoad: true
}
export const portfoliosReducer = (state = initialState, action) => {
    switch (action.type) {
        case profileActionTypes.PORTFOLIOS_REQUEST:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}